<body>
  <div class="bg-gradient-to-b from-white to-gray-300">
    <div class="flex flex-col justify-center items-center h-screen">

      <!-- Contenedor de la imagen de error 404 y el botón -->
      <div class="flex flex-col items-center">
        <img
          src="../../../assets/images/pitzon404.gif"
          alt="ERROR 404"
          class="rounded-lg shadow-lg mb-4"
        />
      </div>

      <!-- Botón responsive -->
      <button class="learn-more mt-4 sm:mt-8 px-6 py-2 sm:px-8 sm:py-3 bottom-24 sm:left-80 left-1/2 transform -translate-x-1/2 sm:translate-x-0" (click)="goToHome()">
        <span class="circle" aria-hidden="true">
          <span class="icon arrow"></span>
        </span>
        <span class="button-text">{{ 'ERROR.BUTTON' | translate }}</span>
      </button>
    </div>
  </div>
</body>
<!-- <app-alerts></app-alerts> -->
<!-- <div class="icons w-10 m-auto bg-white">
    <icon-airplay></icon-airplay>
    <icon-archive></icon-archive>
    <icon-arrow-backward></icon-arrow-backward>
    <icon-arrow-forward></icon-arrow-forward>
    <icon-arrow-left></icon-arrow-left>
    <icon-arrow-wave-left-up></icon-arrow-wave-left-up>
    <icon-at></icon-at>
    <icon-award></icon-award>
    <icon-bar-chart></icon-bar-chart>
    <icon-bell></icon-bell>
    <icon-bell-bing></icon-bell-bing>
    <icon-binance></icon-binance>
    <icon-bitcoin></icon-bitcoin>
    <icon-bolt></icon-bolt>
    <icon-book></icon-book>
    <icon-bookmark></icon-bookmark>
    <icon-box></icon-box>
    <icon-calendar></icon-calendar>
    <icon-camera></icon-camera>
    <icon-chat></icon-chat>
    <icon-check></icon-check>
    <icon-check-circle></icon-check-circle>
    <icon-chevron-down></icon-chevron-down>
    <icon-chevron-left></icon-chevron-left>
    <icon-chevron-right></icon-chevron-right>
    <icon-chevron-up></icon-chevron-up>
    <icon-circle-check></icon-circle-check>
    <icon-close></icon-close>
    <icon-code></icon-code>
    <icon-coffee></icon-coffee>
    <icon-copy></icon-copy>
    <icon-cpu-bolt></icon-cpu-bolt>
    <icon-credit-card></icon-credit-card>
    <icon-desktop></icon-desktop>
    <icon-download></icon-download>
    <icon-dribbble></icon-dribbble>
    <icon-edit></icon-edit>
    <icon-email></icon-email>
    <icon-facebook></icon-facebook>
    <icon-facebook-circle></icon-facebook-circle>
    <icon-file></icon-file>
    <icon-folder></icon-folder>
    <icon-folder-minus></icon-folder-minus>
    <icon-folder-plus></icon-folder-plus>
    <icon-github></icon-github>
    <icon-globe></icon-globe>
    <icon-google></icon-google>
    <icon-heart></icon-heart>
    <icon-help-circle></icon-help-circle>
    <icon-home></icon-home>
    <icon-horizontal-dots></icon-horizontal-dots>
    <icon-inbox></icon-inbox>
    <icon-info-circle></icon-info-circle>
    <icon-info-hexagon></icon-info-hexagon>
    <icon-info-triangle></icon-info-triangle>
    <icon-instagram></icon-instagram>
    <icon-laptop></icon-laptop>
    <icon-layout></icon-layout>
    <icon-layout-grid></icon-layout-grid>
    <icon-link></icon-link>
    <icon-linkedin></icon-linkedin>
    <icon-lock></icon-lock>
    <icon-lock-dots></icon-lock-dots>
    <icon-login></icon-login>
    <icon-logout></icon-logout>
    <icon-mail></icon-mail>
    <icon-mail-dot></icon-mail-dot>
    <icon-map-pin></icon-map-pin>
    <icon-menu></icon-menu>
    <icon-menu-circle></icon-menu-circle>
    <icon-message></icon-message>
    <icon-message-dots></icon-message-dots>
    <icon-messages-dot></icon-messages-dot>
    <icon-microphone-off></icon-microphone-off>
    <icon-minus></icon-minus>
    <icon-minus-circle></icon-minus-circle>
    <icon-mood-smile></icon-mood-smile>
    <icon-moon></icon-moon>
    <icon-multiple-forward-right></icon-multiple-forward-right>
    <icon-netflix></icon-netflix>
    <icon-notes></icon-notes>
    <icon-notes-edit></icon-notes-edit>
    <icon-open-book></icon-open-book>
    <icon-paperclip></icon-paperclip>
    <icon-pencil></icon-pencil>
    <icon-pencil-paper></icon-pencil-paper>
    <icon-phone></icon-phone>
    <icon-phone-call></icon-phone-call>
    <icon-play-circle></icon-play-circle>
    <icon-plus></icon-plus>
    <icon-plus-circle></icon-plus-circle>
    <icon-printer></icon-printer>
    <icon-refresh></icon-refresh>
    <icon-restore></icon-restore>
    <icon-router></icon-router>
    <icon-safari></icon-safari>
    <icon-save></icon-save>
    <icon-search></icon-search>
    <icon-send></icon-send>
    <icon-server></icon-server>
    <icon-settings></icon-settings>
    <icon-share></icon-share>
    <icon-shopping-bag></icon-shopping-bag>
    <icon-shopping-cart></icon-shopping-cart>
    <icon-solana></icon-solana>
    <icon-square-check></icon-square-check>
    <icon-star></icon-star>
    <icon-sun></icon-sun>
    <icon-tag></icon-tag>
    <icon-tether></icon-tether>
    <icon-thumb-up></icon-thumb-up>
    <icon-twitter></icon-twitter>
    <icon-txt-file></icon-txt-file>
    <icon-user></icon-user>
    <icon-user-plus></icon-user-plus>
    <icon-users></icon-users>
    <icon-users-group></icon-users-group>
    <icon-video></icon-video>
    <icon-wheel></icon-wheel>
    <icon-x></icon-x>
    <icon-x-circle></icon-x-circle>
    <icon-zip-file></icon-zip-file>
    <icon-code-file></icon-code-file>
    <icon-car></icon-car>
</div> -->
<footer></footer>
